(() => {
  const PRODUCT_ID = '8044542689314';
  const SALES_FEED_URL = 'https://postor-recent-sales.postorpk2026.workers.dev/recent-sales';
  const SALES_DISMISS_KEY = 'postorP037SalesDismissed';
  const SALES_CONFIG = {
    initialDelayMs: 6000,
    displayMs: 4500,
    gapMs: 5500,
    pollMs: 60000,
    maxShowsPerPage: 3
  };

  function hasDismissedSales() {
    try {
      return sessionStorage.getItem(SALES_DISMISS_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markSalesDismissed() {
    try {
      sessionStorage.setItem(SALES_DISMISS_KEY, '1');
    } catch (error) {
      /* sessionStorage can be unavailable in restricted browsers */
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);
  }

  function initials(name) {
    return String(name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part.charAt(0))
      .join('')
      .slice(0, 2)
      .toUpperCase() || 'P';
  }

  function shuffle(items) {
    const copy = items.slice();
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }

  function initP037CRO() {
    const root = document.querySelector(`product-info[data-product-id="${PRODUCT_ID}"]`);
    if (!root) return;

    document.body.classList.add('postor-p037-cro-active');

    if (root.dataset.postorCroInitialized !== 'true') {
      root.dataset.postorCroInitialized = 'true';
      initStickyAddToCart(root);
    }

    initPurchaseConfidence(root);
    initRecentSalesProof();
  }

  function injectPurchaseConfidenceStyles() {
    if (document.getElementById('postor-p037-confidence-styles')) return;

    const style = document.createElement('style');
    style.id = 'postor-p037-confidence-styles';
    style.textContent = `
      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin: 0.6rem 0 0.9rem;
        padding: 0.2rem 0;
        color: rgb(var(--color-foreground));
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary__rating {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.65rem;
        min-width: 0;
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-rating-stars {
        position: relative;
        display: inline-block;
        width: 7.7rem;
        height: 1.6rem;
        overflow: hidden;
        font-size: 1.55rem;
        line-height: 1;
        letter-spacing: 0.08rem;
        white-space: nowrap;
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-rating-stars__base,
      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-rating-stars__fill {
        position: absolute;
        inset: 0 auto auto 0;
        white-space: nowrap;
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-rating-stars__base {
        color: rgba(var(--color-foreground), 0.18);
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-rating-stars__fill {
        width: var(--postor-rating-fill, 93.4%);
        overflow: hidden;
        color: rgb(var(--color-foreground));
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary__text {
        font-size: 1.2rem;
        line-height: 1.35;
        font-weight: 650;
        letter-spacing: 0;
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary__action {
        flex: 0 0 auto;
        padding: 0;
        border: 0;
        background: transparent;
        color: rgb(var(--color-foreground));
        font: inherit;
        font-size: 1.15rem;
        line-height: 1.3;
        font-weight: 650;
        text-decoration: underline;
        text-underline-offset: 0.22rem;
        cursor: pointer;
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-reassurance {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0;
        margin: 0.9rem 0 0;
        padding: 0.3rem;
        border: 0.1rem solid rgba(var(--color-foreground), 0.12);
        border-radius: 0.9rem;
        background: rgba(var(--color-foreground), 0.025);
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-reassurance__item {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        min-width: 0;
        padding: 0.8rem;
        font-size: 1.12rem;
        line-height: 1.35;
        font-weight: 600;
        letter-spacing: 0;
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-reassurance__item:nth-child(odd) {
        border-right: 0.1rem solid rgba(var(--color-foreground), 0.09);
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-reassurance__item:nth-child(-n+2) {
        border-bottom: 0.1rem solid rgba(var(--color-foreground), 0.09);
      }

      product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-reassurance__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 2rem;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: rgba(var(--color-foreground), 0.08);
        font-size: 1.05rem;
        line-height: 1;
        font-weight: 800;
      }

      @media screen and (max-width: 390px) {
        product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary {
          align-items: flex-start;
        }

        product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary__rating {
          gap: 0.45rem;
        }

        product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary__text,
        product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-review-summary__action {
          font-size: 1.08rem;
        }

        product-info[data-product-id='${PRODUCT_ID}'] .postor-p037-reassurance__item {
          padding: 0.7rem 0.6rem;
          font-size: 1.02rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function initPurchaseConfidence(root) {
    if (root.querySelector('.postor-p037-review-summary')) return;

    const addButton = root.querySelector('button.product-form__submit[name="add"]');
    if (!addButton) return;

    const buttons = addButton.closest('.product-form__buttons') || addButton.parentElement;
    if (!buttons || !buttons.parentNode) return;

    injectPurchaseConfidenceStyles();

    const badge = root.querySelector('.jdgm-prev-badge[data-average-rating][data-number-of-reviews]');
    const parsedRating = badge ? Number.parseFloat(badge.dataset.averageRating) : NaN;
    const parsedCount = badge ? Number.parseInt(badge.dataset.numberOfReviews, 10) : NaN;
    const rating = Number.isFinite(parsedRating) ? parsedRating : 4.67;
    const reviewCount = Number.isFinite(parsedCount) ? parsedCount : 3;
    const ratingPercent = Math.max(0, Math.min(100, (rating / 5) * 100));
    const ratingText = rating.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');

    const reviewTarget = root.querySelector('#judgeme_product_reviews, .jdgm-rev-widg')
      || document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg');

    const summary = document.createElement('div');
    summary.className = 'postor-p037-review-summary';
    summary.setAttribute('aria-label', `${ratingText} out of 5 from ${reviewCount} reviews`);
    summary.innerHTML = `
      <div class="postor-p037-review-summary__rating">
        <span class="postor-p037-rating-stars" role="img" aria-label="${escapeHtml(ratingText)} out of 5 stars" style="--postor-rating-fill:${ratingPercent}%">
          <span class="postor-p037-rating-stars__base" aria-hidden="true">★★★★★</span>
          <span class="postor-p037-rating-stars__fill" aria-hidden="true">★★★★★</span>
        </span>
        <span class="postor-p037-review-summary__text">${escapeHtml(ratingText)}/5 · ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}</span>
      </div>
      ${reviewTarget ? '<button type="button" class="postor-p037-review-summary__action">Read reviews</button>' : ''}
    `;

    const reassurance = document.createElement('div');
    reassurance.className = 'postor-p037-reassurance';
    reassurance.setAttribute('aria-label', 'Order reassurance');
    reassurance.innerHTML = `
      <div class="postor-p037-reassurance__item"><span class="postor-p037-reassurance__icon" aria-hidden="true">✓</span><span>Delivery across Pakistan</span></div>
      <div class="postor-p037-reassurance__item"><span class="postor-p037-reassurance__icon" aria-hidden="true">✓</span><span>Carefully packed for transit</span></div>
      <div class="postor-p037-reassurance__item"><span class="postor-p037-reassurance__icon" aria-hidden="true">✓</span><span>Acrylic unbreakable glass</span></div>
      <div class="postor-p037-reassurance__item"><span class="postor-p037-reassurance__icon" aria-hidden="true">✓</span><span>Secure checkout</span></div>
    `;

    buttons.parentNode.insertBefore(summary, buttons);
    buttons.insertAdjacentElement('afterend', reassurance);

    const reviewButton = summary.querySelector('.postor-p037-review-summary__action');
    if (reviewButton && reviewTarget) {
      reviewButton.addEventListener('click', () => {
        reviewTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function initStickyAddToCart(root) {
    const sticky = document.createElement('div');
    sticky.className = 'postor-p037-sticky';
    sticky.setAttribute('aria-label', 'Quick add to cart');
    sticky.innerHTML = `
      <div class="postor-p037-sticky__meta">
        <span class="postor-p037-sticky__label">Selected option</span>
        <span class="postor-p037-sticky__price"></span>
      </div>
      <button type="button" class="postor-p037-sticky__button">Add to Cart</button>
    `;
    document.body.appendChild(sticky);

    const stickyButton = sticky.querySelector('.postor-p037-sticky__button');
    const stickyLabel = sticky.querySelector('.postor-p037-sticky__label');
    const stickyPrice = sticky.querySelector('.postor-p037-sticky__price');
    let observedButton = null;
    let originalVisible = true;
    let syncQueued = false;

    const observer = new IntersectionObserver((entries) => {
      if (!entries.length) return;
      originalVisible = entries[0].isIntersecting;
      updateStickyVisibility();
    }, { threshold: 0.15 });

    function getAddButton() {
      return root.querySelector('button.product-form__submit[name="add"]');
    }

    function getButtonText(button) {
      if (!button) return '';
      const label = button.querySelector('span:not(.loading__spinner)');
      const text = label ? label.textContent : button.textContent;
      return text ? text.replace(/\s+/g, ' ').trim() : '';
    }

    function getPriceText() {
      const priceBox = root.querySelector('.price');
      if (!priceBox) return '';

      const salePrice = priceBox.classList.contains('price--on-sale')
        ? priceBox.querySelector('.price__sale .price-item--sale, .price-item--sale')
        : null;
      const regularPrice = priceBox.querySelector('.price__regular .price-item--regular, .price-item--regular');
      const priceNode = salePrice || regularPrice;
      return priceNode ? priceNode.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function getSelectedOptionText() {
      const selected = [];

      root.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach((input) => {
        const value = (input.value || '').replace(/\s+/g, ' ').trim();
        if (value && !selected.includes(value)) selected.push(value);
      });

      root.querySelectorAll('.product-form__input select').forEach((select) => {
        const option = select.options && select.options[select.selectedIndex];
        const value = option ? option.textContent.replace(/\s+/g, ' ').trim() : '';
        if (value && !selected.includes(value)) selected.push(value);
      });

      return selected.join(' / ');
    }

    function updateStickyVisibility() {
      const button = getAddButton();
      const shouldShow = window.matchMedia('(max-width: 749px)').matches && button && !originalVisible;
      sticky.classList.toggle('is-visible', Boolean(shouldShow));
      document.body.classList.toggle('postor-p037-sticky-active', Boolean(shouldShow));
    }

    function sync() {
      syncQueued = false;
      const button = getAddButton();
      if (!button) return;

      if (button !== observedButton) {
        if (observedButton) observer.unobserve(observedButton);
        observedButton = button;
        originalVisible = true;
        observer.observe(button);
      }

      const isUnavailable = button.disabled || button.getAttribute('aria-disabled') === 'true';
      const selectedOption = getSelectedOptionText();
      const originalButtonText = getButtonText(button);

      stickyButton.disabled = isUnavailable;
      stickyButton.textContent = isUnavailable
        ? (originalButtonText || 'Unavailable')
        : 'Add to Cart';

      stickyLabel.textContent = selectedOption || 'Selected option';
      stickyLabel.setAttribute('title', selectedOption || 'Selected option');
      stickyPrice.textContent = getPriceText();
      updateStickyVisibility();
    }

    function queueSync() {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(sync);
    }

    stickyButton.addEventListener('click', () => {
      const button = getAddButton();
      if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        button.click();
      }
    });

    root.addEventListener('change', queueSync);
    window.addEventListener('resize', updateStickyVisibility, { passive: true });

    const mutationObserver = new MutationObserver(queueSync);
    mutationObserver.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });

    sync();
  }

  function initRecentSalesProof() {
    if (document.getElementById('postor-p037-fomo-root') || hasDismissedSales()) return;

    const root = document.createElement('div');
    root.id = 'postor-p037-fomo-root';
    root.setAttribute('aria-live', 'polite');
    root.setAttribute('aria-atomic', 'true');
    document.body.appendChild(root);

    let sales = [];
    let queue = [];
    let showCount = 0;
    let timer = null;
    let stopped = false;

    function blockingUiIsOpen() {
      if (document.visibilityState !== 'visible') return true;

      const exitPopup = document.getElementById('postor-cxi-root');
      if (exitPopup && !exitPopup.hidden && exitPopup.classList.contains('is-open')) return true;

      if (document.querySelector('cart-drawer.active, cart-drawer.animate, cart-drawer[open], .cart-drawer.active')) {
        return true;
      }

      return false;
    }

    async function refreshSales() {
      try {
        const response = await fetch(SALES_FEED_URL, { cache: 'no-store' });
        if (!response.ok) return;
        const data = await response.json();
        if (data && Array.isArray(data.sales) && data.sales.length) {
          sales = data.sales.slice();
          queue = shuffle(sales);
        }
      } catch (error) {
        /* Real-sales-only mode: show nothing when the feed is unavailable. */
      }
    }

    function getNextSale() {
      if (!queue.length && sales.length) queue = shuffle(sales);
      return queue.shift();
    }

    function buildCard(sale) {
      const card = document.createElement('div');
      card.className = 'postor-p037-fomo-card';
      card.setAttribute('role', 'status');

      const media = sale.image
        ? `<img class="postor-p037-fomo-card__media" src="${escapeHtml(sale.image)}" alt="" loading="lazy">`
        : `<div class="postor-p037-fomo-card__initials" aria-hidden="true">${escapeHtml(initials(sale.name))}</div>`;

      const name = escapeHtml(sale.name || 'A customer');
      const location = sale.location ? ` in ${escapeHtml(sale.location)}` : '';
      const item = escapeHtml(sale.item || 'wall art');
      const time = Number.isFinite(Number(sale.minutesAgo))
        ? `<span aria-hidden="true">•</span><span>${escapeHtml(sale.minutesAgo)} min ago</span>`
        : '';

      card.innerHTML = `
        ${media}
        <div class="postor-p037-fomo-card__body">
          <p class="postor-p037-fomo-card__copy"><strong>${name}</strong>${location} purchased <span class="postor-p037-fomo-card__item">${item}</span></p>
          <div class="postor-p037-fomo-card__meta">
            <span class="postor-p037-fomo-card__verified">✓ Verified purchase</span>
            ${time}
          </div>
        </div>
        <button type="button" class="postor-p037-fomo-card__close" aria-label="Hide recent purchase notifications">×</button>
      `;

      return card;
    }

    function removeCard(card, callback) {
      if (!card) {
        if (callback) callback();
        return;
      }

      card.classList.remove('is-visible');
      card.classList.add('is-leaving');
      window.setTimeout(() => {
        card.remove();
        if (callback) callback();
      }, 300);
    }

    function scheduleNext(delay = SALES_CONFIG.gapMs) {
      if (stopped || showCount >= SALES_CONFIG.maxShowsPerPage) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(showNext, delay);
    }

    function showNext() {
      if (stopped || showCount >= SALES_CONFIG.maxShowsPerPage) return;

      if (blockingUiIsOpen()) {
        scheduleNext(3000);
        return;
      }

      const sale = getNextSale();
      if (!sale) {
        scheduleNext(5000);
        return;
      }

      root.innerHTML = '';
      const card = buildCard(sale);
      root.appendChild(card);
      showCount += 1;

      requestAnimationFrame(() => card.classList.add('is-visible'));

      const closeButton = card.querySelector('.postor-p037-fomo-card__close');
      closeButton.addEventListener('click', () => {
        stopped = true;
        markSalesDismissed();
        window.clearTimeout(timer);
        removeCard(card, () => root.remove());
      });

      timer = window.setTimeout(() => {
        removeCard(card, () => scheduleNext());
      }, SALES_CONFIG.displayMs);
    }

    refreshSales();
    const pollTimer = window.setInterval(() => {
      if (!stopped && document.visibilityState === 'visible') refreshSales();
    }, SALES_CONFIG.pollMs);

    window.addEventListener('pagehide', () => {
      window.clearInterval(pollTimer);
      window.clearTimeout(timer);
    }, { once: true });

    scheduleNext(SALES_CONFIG.initialDelayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initP037CRO, { once: true });
  } else {
    initP037CRO();
  }
})();
